/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import Tooltip from '@atlaskit/tooltip';

import { overflowEllipsis } from 'src/styles/mixins';

export const SyncButton = styled(Button)<any>(overflowEllipsis('100%'));

export const SyncButtonTooltip = styled(Tooltip)<any>({
  width: '100%',
});
